import React from 'react'
import CreatingForm from '../CreatingForm/CreatingForm'

const CreateProfiles = () => {
  return (
    <div>
      <CreatingForm></CreatingForm>
    </div>
  )
}

export default CreateProfiles
